module.exports = __webpack_public_path__ + "static/media/11A.1dc387d2.jpg";